import { Icon } from '@/components/Icon';
import { PROVIDER_COPY, type PlatformProviderKind } from './platformProvidersModel';

/** "Where to get it": the steps to create the token on the provider's site, and a link that opens it in a new tab. */
export function WhereToGetIt({ kind, className }: { kind: PlatformProviderKind; className?: string }) {
  const copy = PROVIDER_COPY[kind];
  return (
    <section aria-label={`Where to get the ${copy.name} token`} data-testid={`platform-where-${kind}`} className={className}>
      <h3 className="text-xs font-medium text-muted-foreground">Where to get it</h3>
      <ol className="mt-1.5 flex list-decimal flex-col gap-1 pl-4 text-xs leading-relaxed text-subtle marker:text-subtle">
        {copy.where.map((step) => <li key={step} className="break-words">{step}</li>)}
      </ol>
      <a href={copy.site.href} target="_blank" rel="noreferrer noopener" data-testid={`platform-site-${kind}`} className="mt-2 inline-flex min-h-11 items-center gap-1 text-xs text-primary underline-offset-2 hover:underline sm:min-h-0">
        {copy.site.label}
        <Icon name="open_in_new" size={14} />
        <span className="sr-only">(opens in a new tab)</span>
      </a>
    </section>
  );
}
